/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-role.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../../../app/modules/employee/pages/roles/select-role/select-role.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../../app/modules/employee/service/role/role.service';
const styles_SelectRoleComponent:any[] = [i0.styles];
export const RenderType_SelectRoleComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectRoleComponent,data:{}});
function View_SelectRoleComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,
          [8,(null as any)]],{value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),
          0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],{value:[0,'value']},
          (null as any)),(_l()(),i1.ɵted(3,(null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_co.getValue(_v.context.$implicit),
        '');
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',_co.getValue(_v.context.$implicit),
        '');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.selected;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_3);
  });
}
export function View_SelectRoleComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['input',
      1]],(null as any),4,'select',[['class','form-control']],(null as any),[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.SelectRoleComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.change($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectRoleComponent_1)),
      i1.ɵdid(4,802816,(null as any),0,i4.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.SelectRoleComponent = _v.component;
    const currVal_0:any = _co.rolesOptions;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_SelectRoleComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-select-role',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectRoleComponent_0,
      RenderType_SelectRoleComponent)),i1.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i3.SelectRoleComponent]),i1.ɵdid(2,49152,(null as any),0,i3.SelectRoleComponent,
      [i1.Renderer2,i5.RoleService],(null as any),(null as any))],(null as any),(null as any));
}
export const SelectRoleComponentNgFactory:i1.ComponentFactory<i3.SelectRoleComponent> = i1.ɵccf('app-select-role',
    i3.SelectRoleComponent,View_SelectRoleComponent_Host_0,{roleId:'roleId',roleValueId:'roleValueId'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvcm9sZXMvc2VsZWN0LXJvbGUvc2VsZWN0LXJvbGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3JvbGVzL3NlbGVjdC1yb2xlL3NlbGVjdC1yb2xlLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3JvbGVzL3NlbGVjdC1yb2xlL3NlbGVjdC1yb2xlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvcm9sZXMvc2VsZWN0LXJvbGUvc2VsZWN0LXJvbGUuY29tcG9uZW50LnRzLlNlbGVjdFJvbGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VsZWN0ICNpbnB1dCAoY2hhbmdlKT1cImNoYW5nZSgkZXZlbnQpXCIgY2xhc3M9XCJmb3JtLWNvbnRyb2xcIj5cclxuICAgIDxvcHRpb24gdmFsdWU9XCJ7e2dldFZhbHVlKHJvbGUpfX1cIiAqbmdGb3I9XCJsZXQgcm9sZSBvZiByb2xlc09wdGlvbnNcIiBbc2VsZWN0ZWRdPVwicm9sZS5zZWxlY3RlZFwiPnt7cm9sZS5uYW1lfX08L29wdGlvbj5cclxuPC9zZWxlY3Q+XHJcbiIsIjxhcHAtc2VsZWN0LXJvbGU+PC9hcHAtc2VsZWN0LXJvbGU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0NJO01BQUE7YUFBQTtVQUFBLDZEQUFBO1VBQUE7VUFBQSxlQUFnRzs7SUFBeEY7UUFBQTtJQUFSLFdBQVEsU0FBUjtJQUFRO1FBQUE7SUFBUixXQUFRLFNBQVI7O0lBQXFFO0lBQXJFLFdBQXFFLFNBQXJFO0lBQWdHO0lBQUE7Ozs7c0RBRHBHO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBZTtNQUFBO01BQUE7SUFBQTtJQUFmO0VBQUEsZ0NBQThELDhDQUMxRDthQUFBO2FBQUE7NEJBQUEseUNBQXNIO1VBQUEsdUJBQ2pIOztJQUQ4QjtJQUFuQyxXQUFtQyxTQUFuQzs7OztvQkNESjtNQUFBO29DQUFBO01BQUE7UUFBQTtNQUFBLG1DQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/roles/select-role/select-role.component.ngfactory.ts